module.exports = __webpack_public_path__ + "media/images/application/favicon-41328a1be69c429bf279b154c6c879ac.png";